import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import { sendPageview } from 'dpl/util/analytics';
import FullPageQuiz from 'dpl/components/FullPageQuiz';
import ExitModal from 'dpl/adoption_application/components/ExitModal';

import { trackBuyerApplicationQuestionView } from '../utils';
import AdoptionApplicationContext from '../utils/context';

const EMAIL_FORM_KEY = 'buyer_profile_attributes.user_attributes.email';
const PASSWORD_FORM_KEY = 'buyer_profile_attributes.user_attributes.password';

export default class Quiz extends Component {
  static propTypes = {
    didFormSubmissionFail: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formState: PropTypes.object.isRequired,
    getFormErrors: PropTypes.func.isRequired,
    handleFormFieldChange: PropTypes.func.isRequired,
    handleFormSubmission: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isFormSubmitting: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    orderedSteps: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    fixedNav: PropTypes.bool,
    programName: PropTypes.string,
    breederSlug: PropTypes.string,
    breederName: PropTypes.string.isRequired,
    onBeforeNext: PropTypes.func,
    buyerApplicationData: PropTypes.shape({
      invalidate: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    fixedNav: false,
    programName: null,
    breederSlug: null,
    onBeforeNext: null
  };

  static contextType = AdoptionApplicationContext;

  state = { shouldShowExitModal: false };

  handleSaveAndExitClick = () => {
    const { email, password, id, claimed } =
      get(this.props.formState, 'buyer_profile_attributes.user_attributes') ||
      {};

    const errors = this.props.getFormErrors();
    const {
      [EMAIL_FORM_KEY]: emailErrors = [],
      [PASSWORD_FORM_KEY]: passwordErrors = []
    } = errors;

    if (
      (id && claimed) ||
      (email && password && !emailErrors.length && !passwordErrors.length)
    ) {
      this.saveAndExit();
      return;
    }

    this.setState({ shouldShowExitModal: true });
  };

  handleExitModalCloseClick = () => {
    this.setState({ shouldShowExitModal: false });
  };

  saveAndExit = async e => {
    e && e.preventDefault();

    const { buyerApplicationData, handleFormSubmission, onCloseClick } =
      this.props;

    try {
      await handleFormSubmission();
      // force a refetch next time we enter the quiz flow
      // so we don't try to create two new separate buyer applications
      buyerApplicationData.invalidate();
      onCloseClick();
    } catch (err) {
      onCloseClick();
      throw err;
    }
  };

  handleNextClicked = stepIndex => {
    this.logPageviewForStep(this.props.orderedSteps[stepIndex]);
  };

  logPageviewForStep = step => {
    if (step && step.questionName) {
      const { programName, breederSlug, breederName } = this.props;
      sendPageview({
        page_path: `/adopter_app/${step.questionName}`
      });
      trackBuyerApplicationQuestionView(
        step.questionTitle ? step.questionTitle : step.questionName,
        { programName, breederSlug, breederFirstName: breederName },
        step.questionName
      );
    }
  };

  componentDidMount() {
    const { index, orderedSteps } = this.props;
    this.logPageviewForStep(orderedSteps[index]);
  }

  render() {
    const {
      didFormSubmissionFail,
      formState,
      getFormErrors,
      handleFormFieldChange,
      index,
      isFormSubmitting,
      onCloseClick,
      orderedSteps,
      onBeforeNext,
      onSubmit,
      fixedNav,
      programName,
      breederSlug
    } = this.props;
    const { shouldShowExitModal } = this.state;

    const formErrors = getFormErrors();

    return (
      <div className="AdoptionApplicationQuiz">
        <FullPageQuiz
          formErrors={formErrors}
          formState={formState}
          handleFormFieldChange={handleFormFieldChange}
          initialIndex={index}
          isFormSubmitting={isFormSubmitting}
          onSaveAndExitClick={this.handleSaveAndExitClick}
          orderedSteps={orderedSteps}
          onNextClick={this.handleNextClicked}
          onSubmit={onSubmit}
          fixedNav={fixedNav}
          onBeforeNext={onBeforeNext}
          isLoading={this.context.isSubmittingAndRefetching}
        />
        {shouldShowExitModal && (
          <ExitModal
            onForceCloseClick={onCloseClick}
            onSignupClick={this.saveAndExit}
            onCloseClick={this.handleExitModalCloseClick}
            formErrors={formErrors}
            formState={formState}
            onChange={handleFormFieldChange}
            displayErrors={didFormSubmissionFail}
            programName={programName}
            breederSlug={breederSlug}
          />
        )}
      </div>
    );
  }
}
